exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bor[data-v-b7146d06]{height:1px;margin:20px 0;background-color:#ebedf0}.icon[data-v-b7146d06]{width:20px;height:20px;vertical-align:-0.15em;fill:currentColor;overflow:hidden}.uploadImg[data-v-b7146d06] .uploadIMG .el-dialog__body{height:280px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.uploadImg .disable[data-v-b7146d06] .el-upload{display:none !important}", ""]);

// exports
